import { Component, ElementRef, ViewChild, OnDestroy, AfterViewInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-json-editor',
  standalone: true,
  template: `
    <div #editorContainer style="height: 500px;"></div>
  `,
})
export class JsonEditorComponent implements AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('editorContainer', { static: false }) editorContainer!: ElementRef;
  @Input() data: any = {};
  private editor: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  async ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    const JSONEditor = (await import('jsoneditor')).default;

    this.editor = new JSONEditor(this.editorContainer.nativeElement, {
      mode: 'tree'
    });

    if (this.data) {
      this.editor.set(this.data);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.editor && !changes['data'].firstChange) {
      this.editor.set(this.data || {});
    }
  }

  ngOnDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  }
}